import _ from 'lodash';
import { sanitizePII } from '@wix/bi-logger-sanitizer';
var sanitizeEvent = function (event) { return _.mapValues(event, sanitizePII); };
export var loggerFactory = function (biFactory, mutator) {
    if (mutator === void 0) { mutator = function (x) { return x; }; }
    var logger = biFactory.logger();
    return _.flow(mutator, sanitizeEvent, logger.log.bind(logger));
};
export var BI_DASHBOARD_ENDPOINT = 'expert-dashboard';
export var BI_FEEDBACK_ENDPOINT = 'get-feedback';
export var BI_ARENA_ENDPOINT = 'marketplace';
export var BI_LOYALTY_ENDPOINT = 'loyalty-program';
export var BI_SOURCE = 80;
//# sourceMappingURL=bi.js.map